/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Pricing_DescInputs */

const en_st_pricing_desc = /** @type {(inputs: St_Pricing_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For agencies and freelancers who deliver for clients.`)
};

const id_st_pricing_desc = /** @type {(inputs: St_Pricing_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untuk agensi dan freelancer yang mengerjakan proyek klien.`)
};

/**
* | output |
* | --- |
* | "For agencies and freelancers who deliver for clients." |
*
* @param {St_Pricing_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_pricing_desc = /** @type {((inputs?: St_Pricing_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Pricing_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_pricing_desc(inputs)
	return en_st_pricing_desc(inputs)
});